const author_blogs = () => {
    var isLoading = false;
    let currentpage = 1; // Start from the second page since the first page is already loaded
  
    const button = document.getElementById('load-more-button');
    const postContainer = document.getElementById('postContainer');

    $( document ).ready(function() {
      if(postContainer) {

        if (post_count <= 4) {
            $(button).hide();
        }
    }
  });
    
  
    if (button) {
      $(button).on('click', function () {
        if (!isLoading) {
          isLoading = true;
  
          var data = {
            'action': 'load_more_posts',
            'currentpage': currentpage,
            'author_id': authorId
          };
  
          // $('.loading-spinner').addClass('show');
  
  
          $.ajax({
            url: ajax_vars.ajax_url, // AJAX handler
            dataType: 'json',
            data: data,
            type: 'POST',
            success: function (res) {
              setTimeout(() => {
                currentpage += 1;

                if(currentpage >= 3) {
                    $(button).hide();
                }

                // $('.loading-spinner').removeClass('show');
                
                $(postContainer).append(res.html);
                isLoading = false;
  
              }, 5);
            },
            error: function (result) {
              console.warn(result);
              isLoading = false;
            }
          });
        }
      });
    }


  };
  
  export default author_blogs;
  